import { createContext, useContext } from 'react';
import type { Store } from '../modules/auth';
import type { DemoState } from './demoState';
import type { PaymentMethod } from '../modules/invoices/api/invoicesApi';
import type { BookingAdjustment } from './bookingDecision';

export interface DemoContextValue extends DemoState {
  store: Store;
  setStore: (store: Store) => void;
  addAppointment: (item: DemoState['appointments'][number]) => void;
  addCustomers: (items: DemoState['customers']) => void;
  saveService: (item: DemoState['services'][number]) => void;
  addInvoice: (item: DemoState['invoices'][number]) => void;
  saveCustomer: (item: DemoState['customers'][number]) => void;
  addExpense: (item: DemoState['expenses'][number]) => void;
  saveEmployee: (item: DemoState['employees'][number]) => void;
  saveSettings: (item: DemoState['settings'][number]) => void;
  settleInvoice: (id: string, method: PaymentMethod, cash?: number) => void;
  approveBooking: (id: string, adjustment: BookingAdjustment) => void;
  declineBooking: (id: string, reason: string) => void;
}
export const DemoContext = createContext<DemoContextValue | null>(null);
export function useDemo() {
  const value = useContext(DemoContext);
  if (!value) throw new Error('DemoProvider is required.');
  return value;
}
